import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useSessionTimeout } from "@/hooks/useSessionTimeout";
import { SessionTimeoutDialog } from "./SessionTimeoutDialog";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";

interface SessionTimeoutProviderProps {
  children: React.ReactNode;
}

export function SessionTimeoutProvider({ children }: SessionTimeoutProviderProps) {
  const navigate = useNavigate();
  const { user, profile } = useAuth();

  const handleTimeout = async () => {
    // Log security event before signing out
    if (profile?.organization_id) {
      try {
        await supabase.from("security_events").insert({
          organization_id: profile.organization_id,
          user_id: user?.id,
          event_type: "session_timeout",
          severity: "low",
          details: { reason: "inactivity" },
        });
      } catch (error) {
        console.error("Failed to log session timeout:", error);
      }
    }

    await supabase.auth.signOut();
    toast.info("Your session has expired due to inactivity");
    navigate("/login");
  };

  const { showWarning, remainingSeconds, extendSession } = useSessionTimeout({
    onTimeout: handleTimeout,
  });

  return (
    <>
      {children}
      <SessionTimeoutDialog
        open={showWarning}
        remainingSeconds={remainingSeconds}
        onExtendSession={extendSession}
      />
    </>
  );
}
